import {
  Label,
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import { FC, Fragment, useEffect, useState, useRef } from "react";

import { ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Option = { id: number | string; name: string };

export type MultiSelectWithAllOptionProps = {
  options: Option[];
  selectedOptions: Option[];
  setSelectedOptions: (options: Option[]) => void;
  title: string;
  textDescribe?: string;
  span?: string;
};

export const MultiSelectWithAllOption: FC<MultiSelectWithAllOptionProps> = ({
  options,
  selectedOptions = [],
  setSelectedOptions,
  title,
  textDescribe,
  span,
}) => {
  const [isAbove, setIsAbove] = useState(false);
  const listboxRef = useRef<HTMLDivElement>(null);

  /*
  const handleChange = (selectedOption: Option) => {
    if (selectedOption.id === "all") {
      setSelectedOptions([selectedOption]);
    } else {
      const isAlreadySelected = selectedOptions.some(
        (option) => option.id === selectedOption.id
      );

      const updatedOptions = isAlreadySelected
        ? selectedOptions.filter((option) => option.id !== selectedOption.id)
        : [...selectedOptions, selectedOption];

      setSelectedOptions(updatedOptions);
    }
  };
  */

  const handleChange = (selectedOption: Option) => {
    if (selectedOption.id === "all") {
      setSelectedOptions([selectedOption, ...options]);
      return null;
    }

    const isAlreadySelected = selectedOptions.some(
      (option) => option.id === selectedOption.id
    );

    const updatedOptions = isAlreadySelected
      ? selectedOptions.filter((option) => option.id !== selectedOption.id)
      : [...selectedOptions, selectedOption];

    if (JSON.stringify(updatedOptions) !== JSON.stringify(selectedOptions)) {
      setSelectedOptions(updatedOptions);
    }
  };

  useEffect(() => {
    const handlePosition = () => {
      if (listboxRef.current) {
        const rect = listboxRef.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        if (windowHeight - rect.bottom < 300) {
          setIsAbove(true);
        } else {
          setIsAbove(false);
        }
      }
    };

    window.addEventListener("resize", handlePosition);
    window.addEventListener("scroll", handlePosition);

    handlePosition();

    return () => {
      window.removeEventListener("resize", handlePosition);
      window.removeEventListener("scroll", handlePosition);
    };
  }, []);

  const allOption: Option = {
    id: "all",
    name: ` Todo el personal (incluido de otras filiales) `,
  };
  const displayOptions = [allOption, ...options];

  useEffect(() => {
    if (displayOptions) {
      console.log("displayOptions", displayOptions);
    }
  }, [displayOptions]);

  return (
    <Fragment>
      <Listbox
        value={selectedOptions}
        onChange={(option) => {
          handleChange(option);
        }}
      >
        <div ref={listboxRef}>
          <div className="flex justify-between">
            <Label className="block text-sm font-medium leading-6 text-gray-600">
              {title}
            </Label>
            <span className={`text-sm leading-6 text-gray-500`}>{span}</span>
          </div>

          <div className="relative">
            <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-400 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-primary sm:text-sm sm:leading-6">
              <span className="block truncate">
                {selectedOptions && selectedOptions.length > 0
                  ? selectedOptions.map((o: any) => o.name).join(", ")
                  : "Nada Seleccionado"}
              </span>
              <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                <ChevronUpDownIcon
                  aria-hidden="true"
                  className="h-5 w-5 text-gray-300"
                />
              </span>
            </ListboxButton>

            <ListboxOptions
              transition
              className={`absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-sm shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none ${
                isAbove ? "bottom-full mb-1" : "top-full mt-1"
              }`}
            >
              {displayOptions.map((option) => (
                <ListboxOption
                  key={option.id}
                  value={option}
                  className={`group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-600 data-[focus]:bg-primary data-[focus]:text-white ${
                    selectedOptions.some((o: any) => o.id === "all") &&
                    option.id !== "all"
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                  }`}
                  disabled={
                    selectedOptions.some((o: any) => o.id === "all") &&
                    option.id !== "all"
                  }
                >
                  <span className="block truncate font-normal group-data-[selected]:font-semibold">
                    {option.name}
                  </span>

                  {selectedOptions.some((o: any) => o.id === option.id) && (
                    <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-primary-600 group-hover:text-white">
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="h-5 w-5"
                        aria-hidden="true"
                      />
                    </span>
                  )}
                </ListboxOption>
              ))}
            </ListboxOptions>
          </div>
          <p className="mt-1 text-sm text-gray-400">{textDescribe}</p>
        </div>
      </Listbox>
    </Fragment>
  );
};
